import { UserExtensionModel } from '@/types';
import BaseService from '@/services/api/BaseService';

class UserExtension extends BaseService<UserExtensionModel> {}

export default new UserExtension('users/extensions');
